export type LevelKey = 'beginner' | 'mid' | 'challenge'

export interface Level {
  key: LevelKey
  label: string
  shortLabel: string
  dotClass: string
  textClass: string
}

export const levels: Level[] = [
  { key: 'beginner', label: 'Początkujący', shortLabel: 'początkujący', dotClass: 'bg-level-beginner', textClass: 'text-level-beginner' },
  { key: 'mid', label: 'Średni', shortLabel: 'średni', dotClass: 'bg-level-mid', textClass: 'text-level-mid' },
  { key: 'challenge', label: 'Wyzwanie', shortLabel: 'wyzwanie', dotClass: 'bg-level-challenge', textClass: 'text-level-challenge' },
]

/** The 16-week semester plan shown in the hero grid. */
export const semesterWeeks: string[] = [
  'Swing feel i comping',
  'Rytm i metrum',
  'Akordy septymowe',
  'Voicingi shell',
  'ii-V-I',
  'ii-V-I w molu',
  'Dźwięki prowadzące',
  'Arpeggia',
  'Drop-2',
  'Skale modalne',
  'Frazowanie',
  'Artykulacja',
  'Słownictwo bebopowe',
  'Analiza standardu',
  'Solówka na standard',
  'Jam session + ocena',
]

export interface WeekExample {
  week: number
  topic: string
  exercises: Record<LevelKey, number>
  theory: string
  homework: string
}

/** Sample weeks for the "Tak wygląda Twój semestr" carousel. */
export const weekExamples: WeekExample[] = [
  {
    week: 1,
    topic: 'Swing feel i comping',
    exercises: { beginner: 1, mid: 2, challenge: 3 },
    theory: 'Tom 02, str. 12',
    homework: 'Comping na bluesie F przez 10 minut dziennie, metronom na 2 i 4.',
  },
  {
    week: 8,
    topic: 'Arpeggia',
    exercises: { beginner: 22, mid: 23, challenge: 24 },
    theory: 'Tom 05, str. 34',
    homework: 'Zagraj arpeggia akordów „Autumn Leaves” w jednej pozycji, bez zatrzymywania.',
  },
  {
    week: 16,
    topic: 'Jam session + ocena',
    exercises: { beginner: 48, mid: 49, challenge: 50 },
    theory: 'Tom 06, str. 58',
    homework: 'Przygotuj jeden standard do wspólnego jamu. Nauczyciel uzupełnia arkusz ocen.',
  },
]
